var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-footer flex flex-m"},[_c('div',{staticClass:"mr-5"},[_vm._v("Copyright© 2020-2021 佛山市佰方融通数据服务有限公司 All Rights Reserved |")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("粤ICP备20050400号")])])
}]

export { render, staticRenderFns }